// GENERATED FILE 
// DO NOT TOUCH!!! 
import emptyIcon from "url:./empty_icon.png";
import key1Image from "url:./key1Image.jpg";
import key2Image from "url:./key2Image.jpg";
import key3Image from "url:./key3Image.jpg";
import key4Image from "url:./key4Image.jpg";
import key5Image from "url:./key5Image.jpg";
import key6Image from "url:./key6Image.jpg";
import key7Image from "url:./key7Image.jpeg";
import key8Image from "url:./key8Image.jpg";
import key9Image from "url:./key9Image.jpg";
import key10Image from "url:./key10Image.jpg";
import key11Image from "url:./key11Image.png";
import key12Image from "url:./key12Image.png";
import key13Image from "url:./key13Image.png";
import key14Image from "url:./key14Image.png";
const images = {
emptyIcon,
key1Image,
key2Image,
key3Image,
key4Image,
key5Image,
key6Image,
key7Image,
key8Image,
key9Image,
key10Image,
key11Image,
key12Image,
key13Image,
key14Image,
}
export default images;